// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditStep_deleteButton__EiWg+","field":"EditStep_field__6oIHi","text":"EditStep_text__er-XC"};